import profileOverview from '@/assets/home/profile-overview.png';
import profileEdit from '@/assets/home/profile-edit.png';
import tricksList from '@/assets/home/tricks-list.png';
import rulebooksView from '@/assets/home/rulebooks-view.png';
import trainingArea from '@/assets/home/training-area.png';
import competitionsHub from '@/assets/home/competitions-hub.png';
import competitionsDetail from '@/assets/home/competitions-detail.png';
import communityAthletes from '@/assets/home/community-athletes.png';
import communityJudges from '@/assets/home/community-judges.png';
import communityOrganizers from '@/assets/home/community-organizers.png';

export const homeSlideDefinitions = [
  {
    id: 'profile',
    themeClass: 'theme-profile',
    eyebrowKey: 'home.slides.profile.eyebrow',
    eyebrowFallback: 'Profile',
    titleKey: 'home.slides.profile.title',
    titleFallback: 'Your profile is now a real home base',
    descriptionKey: 'home.slides.profile.description',
    descriptionFallback: 'Keep your public identity updated, review your role context and make sure the rest of the community sees the right version of you.',
    points: [
      {
        key: 'home.slides.profile.point_1',
        fallback: 'Review your public card and image in one place.',
      },
      {
        key: 'home.slides.profile.point_2',
        fallback: 'Edit your details before judges, athletes and organizers find you.',
      },
    ],
    media: [
      {
        src: profileOverview,
        altKey: 'home.slides.profile.media_1_alt',
        altFallback: 'Profile overview preview',
        captionKey: 'home.slides.profile.media_1_caption',
        captionFallback: 'Profile overview',
      },
      {
        src: profileEdit,
        altKey: 'home.slides.profile.media_2_alt',
        altFallback: 'Profile editing preview',
        captionKey: 'home.slides.profile.media_2_caption',
        captionFallback: 'Editing view',
      },
    ],
    actions: [
      {
        id: 'open-profile',
        kind: 'route',
        to: '/profile',
        labelKey: 'home.actions.open_profile',
        labelFallback: 'Open my profile',
        variant: 'primary',
      },
    ],
  },
  {
    id: 'trick-list',
    themeClass: 'theme-tricks',
    eyebrowKey: 'home.slides.trick_list.eyebrow',
    eyebrowFallback: 'List Trick',
    titleKey: 'home.slides.trick_list.title',
    titleFallback: 'Browse the trick library like a working tool',
    descriptionKey: 'home.slides.trick_list.description',
    descriptionFallback: 'The trick list is no longer a static appendix. It works as a reference board for names, cases and combinations while you train or judge.',
    points: [
      {
        key: 'home.slides.trick_list.point_1',
        fallback: 'Check cases and combos without leaving the app rhythm.',
      },
      {
        key: 'home.slides.trick_list.point_2',
        fallback: 'Use it as a quick visual dictionary before scoring or recording.',
      },
    ],
    media: [
      {
        src: tricksList,
        altKey: 'home.slides.trick_list.media_1_alt',
        altFallback: 'Trick list preview',
        captionKey: 'home.slides.trick_list.media_1_caption',
        captionFallback: 'Structured trick list',
      },
    ],
    actions: [
      {
        id: 'open-trick-list',
        kind: 'route',
        to: '/trickList',
        labelKey: 'home.actions.open_trick_list',
        labelFallback: 'Open trick list',
        variant: 'primary',
      },
    ],
  },
  {
    id: 'rulebooks',
    themeClass: 'theme-rulebooks',
    eyebrowKey: 'home.slides.rulebooks.eyebrow',
    eyebrowFallback: 'RuleBooks',
    titleKey: 'home.slides.rulebooks.title',
    titleFallback: 'Rules are now easier to consult under pressure',
    descriptionKey: 'home.slides.rulebooks.description',
    descriptionFallback: 'When you need to verify a rule, the app should answer fast. This section is meant to keep the language clear and the access immediate.',
    points: [
      {
        key: 'home.slides.rulebooks.point_1',
        fallback: 'Use it as a judge reference without digging through PDFs.',
      },
      {
        key: 'home.slides.rulebooks.point_2',
        fallback: 'Keep key criteria close when reviewing rounds or explaining decisions.',
      },
    ],
    media: [
      {
        src: rulebooksView,
        altKey: 'home.slides.rulebooks.media_1_alt',
        altFallback: 'Rulebooks preview',
        captionKey: 'home.slides.rulebooks.media_1_caption',
        captionFallback: 'Fast rule access',
      },
    ],
    actions: [
      {
        id: 'open-rulebooks',
        kind: 'route',
        to: '/rulebooks',
        labelKey: 'home.actions.open_rulebooks',
        labelFallback: 'Open rulebooks',
        variant: 'primary',
      },
    ],
  },
  {
    id: 'training',
    themeClass: 'theme-training',
    eyebrowKey: 'home.slides.training.eyebrow',
    eyebrowFallback: 'Training Area',
    titleKey: 'home.slides.training.title',
    titleFallback: 'Training becomes something you can revisit and improve',
    descriptionKey: 'home.slides.training.description',
    descriptionFallback: 'Save rounds, review material and keep an evolving record of how you are building consistency before competition day.',
    points: [
      {
        key: 'home.slides.training.point_1',
        fallback: 'Store rounds and return to them without losing context.',
      },
      {
        key: 'home.slides.training.point_2',
        fallback: 'Use the area as a practical bridge between rehearsal and real events.',
      },
    ],
    media: [
      {
        src: trainingArea,
        altKey: 'home.slides.training.media_1_alt',
        altFallback: 'Training area preview',
        captionKey: 'home.slides.training.media_1_caption',
        captionFallback: 'Training rounds and review',
      },
    ],
    actions: [
      {
        id: 'open-training',
        kind: 'route',
        to: '/training',
        labelKey: 'home.actions.open_training',
        labelFallback: 'Open training area',
        variant: 'primary',
      },
    ],
    visibleWhen(context) {
      return context.canAccessTraining;
    },
  },
  {
    id: 'competitions',
    themeClass: 'theme-competitions',
    eyebrowKey: 'home.slides.competitions.eyebrow',
    eyebrowFallback: 'Competitions',
    titleKey: 'home.slides.competitions.title',
    titleFallback: 'Competitions are no longer a hidden control panel',
    descriptionKey: 'home.slides.competitions.description',
    descriptionFallback: 'Explore events, inspect rounds, review videos and manage the full flow with much more visibility than before.',
    points: [
      {
        key: 'home.slides.competitions.point_1',
        fallback: 'Open a competition and understand what is happening at a glance.',
      },
      {
        key: 'home.slides.competitions.point_2',
        fallback: 'Move from overview to detail, scoring and media without breaking context.',
      },
    ],
    media: [
      {
        src: competitionsHub,
        altKey: 'home.slides.competitions.media_1_alt',
        altFallback: 'Competitions overview preview',
        captionKey: 'home.slides.competitions.media_1_caption',
        captionFallback: 'Competitions overview',
      },
      {
        src: competitionsDetail,
        altKey: 'home.slides.competitions.media_2_alt',
        altFallback: 'Competition detail preview',
        captionKey: 'home.slides.competitions.media_2_caption',
        captionFallback: 'Round and media detail',
      },
    ],
    actions: [
      {
        id: 'open-competitions',
        kind: 'route',
        to: '/competitions',
        labelKey: 'home.actions.open_competitions',
        labelFallback: 'Open competitions',
        variant: 'primary',
      },
    ],
  },
  {
    id: 'community',
    themeClass: 'theme-community',
    eyebrowKey: 'home.slides.community.eyebrow',
    eyebrowFallback: 'Community',
    titleKey: 'home.slides.community.title',
    titleFallback: 'Meet the people behind the rounds and events',
    descriptionKey: 'home.slides.community.description',
    descriptionFallback: 'Community should feel discoverable. This slide groups athletes, judges and organizers so you can jump straight into the people side of TJS.',
    points: [
      {
        key: 'home.slides.community.point_1',
        fallback: 'Browse athlete, judge and organizer spaces from one entry point.',
      },
      {
        key: 'home.slides.community.point_2',
        fallback: 'Use it to understand who is active around the platform right now.',
      },
    ],
    media: [
      {
        src: communityAthletes,
        altKey: 'home.slides.community.media_1_alt',
        altFallback: 'Athletes community preview',
        captionKey: 'home.slides.community.media_1_caption',
        captionFallback: 'Athletes',
      },
      {
        src: communityJudges,
        altKey: 'home.slides.community.media_2_alt',
        altFallback: 'Judges community preview',
        captionKey: 'home.slides.community.media_2_caption',
        captionFallback: 'Judges',
      },
      {
        src: communityOrganizers,
        altKey: 'home.slides.community.media_3_alt',
        altFallback: 'Organizers community preview',
        captionKey: 'home.slides.community.media_3_caption',
        captionFallback: 'Organizers',
      },
    ],
    actions: [
      {
        id: 'open-athletes',
        kind: 'route',
        to: '/athletes',
        labelKey: 'home.actions.open_athletes',
        labelFallback: 'Athletes',
        variant: 'primary',
      },
      {
        id: 'open-judges',
        kind: 'route',
        to: '/judges',
        labelKey: 'home.actions.open_judges',
        labelFallback: 'Judges',
        variant: 'secondary',
      },
      {
        id: 'open-organizers',
        kind: 'route',
        to: '/organizer',
        labelKey: 'home.actions.open_organizers',
        labelFallback: 'Organizers',
        variant: 'secondary',
      },
    ],
  },
];